//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectDoctypeStep from "../components/wizard/SelectDoctypeStep";
import ChoosePredictionsStep from "../components/wizard/ChoosePredictionsStep";
import SelectFieldsStep from "../components/wizard/SelectFieldsStep";
import SummaryStep from "../components/wizard/SummaryStep";
import ConfirmDialog from "../components/ConfirmDialog";
import FieldEditDialog from "../components/wizard/FieldEditDialog";
import CheckedDescription from "../components/CheckedDescription";
import SelectedModelSidePanel from "../components/SelectedModelSidePanel";
import ModelOverviewSidePanel from "../components/ModelOverviewSidePanel";
import {mapGetters, mapMutations} from "vuex";
import analyzer from "../analysis";

export default {
  name: "Wizard",
  components: {
    SelectDoctypeStep,
    ChoosePredictionsStep,
    SelectFieldsStep,
    SummaryStep,
    ConfirmDialog,
    FieldEditDialog,
    SelectedModelSidePanel,
    ModelOverviewSidePanel,
    CheckedDescription,
  },

  data() {
    return {
      hideModelPanel: true,
      modelType: "Document",
      active: "first",
      index: 0,
      first: false,
      second: false,
      third: false,
      fourth: false,
      steps: ["first", "second", "third", "fourth"],
      statistics: [],
      disableNext: true,
    };
  },

  beforeDestroy() {
    console.log("Destroying wizard");
    this.setNewModel({});
  },

  computed: {
    ...mapGetters(["newModel", "showDialog", "projectId", "currentModel"]),

    nxClient: function () {
      return this.$refs.nuxeoPP.$.nxResource.$.nx.client;
    },

    inputs: function () {
      return this._computeFields(this.newModel.selectedFieldsProperties);
    },

    inputProperties: function () {
      return this._computeProperties(this.inputs);
    },

    outputs: function () {
      return this._computeFields(this.newModel.selectedPredictionProperties);
    },

    outputProperties: function () {
      return this._computeProperties(this.outputs);
    },
  },

  watch: {
    newModel: function () {
      this.disableNext = !this.validate();
      this.modelType = this.newModel.selectedDocType;
      if (this.modelType !== undefined && this.index === 0) {
        this.hideModelPanel = false;
        this._recompute();
      }
    }
  },

  methods: {
    stepChanged() {
      this.index = this.steps.indexOf(this.active);
      if (this.newModel && this.newModel.properties && this.index === 1) {
        const tmpModel = Object.assign({}, this.newModel);
        tmpModel.propertiesReady = true;
        this.setNewModel(tmpModel);
      }

      switch (this.index) {
        case 1:
          setTimeout(() => {
            this.$refs.choosePrdictionStep.statistics = this.statistics;
            this.$refs.editDialog.allProperties = this.statistics;
          }, 300);
          break;
        case 2:
          setTimeout(() => {
            this.$refs.selectFieldsStep.statistics = this.statistics;
          }, 300);
          break;
        case 3:
          this.hideModelPanel = true;
          break;
        default:
          // NOP
      }
    },

    openAbort() {
      this.setShowDialog(true);
    },

    navigateToDashboard() {
      this.$router.push({name: "dashboard"});
    },

    next() {
      // Wizard steps procedure
      // this.hideModelPanel = true;
      this[this.active] = true;
      this.active = this.steps[++this.index];
      this.disableNext = !this.validate();
    },

    previous() {
      // Wizard steps procedure
      this[this.active] = true;
      this.active = this.steps[--this.index];
      this.disableNext = !this.validate();
    },

    switchStep(step) {
      this.active = step;
      this.disableNext = !this.validate();
    },

    validate() {
      switch (this.index) {
        case 0:
          return this.newModel.selectedDocType != null;
        case 1:
          return (
              this.newModel.selectedPredictionProperties &&
              this.newModel.selectedPredictionProperties.length > 0
          );
        case 2:
          return (
              this.newModel.selectedFieldsProperties &&
              this.newModel.selectedFieldsProperties.length > 0
          );
        case 3:
          return (
              this.newModel.selectedDocType != null &&
              this.newModel.selectedPredictionProperties &&
              this.newModel.selectedPredictionProperties.length > 0 &&
              this.newModel.selectedFieldsProperties &&
              this.newModel.selectedFieldsProperties.length > 0 &&
              this.newModel.algorithm &&
              this.newModel.name
          );
        default:
          return false;
      }
    },

    hideShowModelPanel() {
      this.hideModelPanel = !this.hideModelPanel;
    },

    submit() {
      if (this.newModel.selectedDocType === null) {
        this.displayError(this.$t("wizard.error.no.doc.type"));
        return;
      }

      if (
          !this.newModel.selectedPredictionProperties ||
          !this.newModel.selectedPredictionProperties.length
      ) {
        this.displayError(this.$t("wizard.error.no.prediction.properties"));
        return;
      }

      if (
          !this.newModel.selectedFieldsProperties ||
          !this.newModel.selectedFieldsProperties.length
      ) {
        this.displayError(this.$t("wizard.error.no.basedon.properties"));
        return;
      }

      if (!this.newModel.name) {
        this.displayError(this.$t("wizard.error.no.model.name"));
        return;
      }

      if (!this.newModel.algorithm) {
        this.displayError(this.$t("wizard.error.no.algorithm.selected"));
        return;
      }

      var aiModel = {
        type: "AI_Model",
        name: this.newModel.name,
        "entity-type": "aiModel",
      };

      const modelName = this.newModel.name.replace(/\W|_/g, "");
      aiModel.properties = {
        "dc:title": this.newModel.name,
        "ai_model:name": modelName,
        "dc:description": this.newModel.description,
        "ai_model:training_algorithm_document": this.newModel.algorithm,
        "ai_model:doc_type": this.newModel.selectedDocType,
        "ai_model:query_filter_params": this.newModel.nxql,
        "ai_model:inputs": this.inputs,
        "ai_model:outputs": this.outputs,
        "ai_model:datasource": "dev"
      };

      console.log("Creating aiModel with parameters", aiModel);

      var pp = this.$refs.nuxeoPP;
      pp.query = `SELECT * FROM Document WHERE ecm:primaryType = 'AIResourcesContainer' AND ecm:isTrashed = 0 AND ecm:isVersion = 0 AND airc:projectid = '${this.projectId}'`;
      pp.params.queryParams = null;

      this.$refs.aiDatasource.execute()
          .then((datasource) => {
            aiModel.properties["ai_model:datasource"] = datasource.value
            return pp.fetch();
          })
          .catch((err) => {
            console.log("Couldn't obtain Datasource", err);
            this.displayError(err);
          })
          .then((resp) => {
            console.log("Resource content found", resp.entries[0]);
            return resp.entries[0].path;
          })
          .then((path) => {
            console.log("AIResourceContainer path:", path);
            if (!path) {
              throw new Error("Couldn't obtain path");
            }

            return this.nxClient.repository().create(path + "/models", aiModel);
          })
          .then((doc) => {
            console.log("Updated current doc", doc);
            return this._export(doc.uid, modelName);
          })
          .then((exportInfo) => {
            this.displaySuccess(this.$t("admin.ai.export.success"));
            this.$router.push({
              name: "model",
              params: {
                id: exportInfo.modelId,
              },
            });
          })
          .catch((err) => {
            console.log(err);
            this.displayError(this.$t("admin.ai.export.error"));
          });
    },

    _export(modelId, modelName) {
      this.$refs.aiExport.params = {
        query: this._computeNXQL(),
        inputProperties: this.inputProperties,
        outputProperties: this.outputProperties,
        model_id: modelId,
        model_name: modelName,
      };
      console.log(
          `AI.Export parameters: ${JSON.stringify(this.$refs.aiExport.params)}`
      );

      return this.$refs.aiExport.execute().then((resp) => {
        return new Promise((resolve) => {
          resolve({
            id: resp.value,
            modelId: modelId,
          });
        });
      });
    },

    _computeFields(fields) {
      return fields
          .map((item) => {
            return {
              name: item.field,
              multi_class: item.multiClass,
              language: item.language ? item.language : "en",
              categories: this._toTermArr(item.terms),
              type: item.type,
            };
          }, []);
    },

    _computeProperties(fields) {
      var props = {};
      fields.forEach((item) => {
        props[item.name] = item.type;
      });

      return props;
    },

    _toTermArr(termStr) {
      if (termStr) {
        return eval(termStr)
            .map((item) => item.key)
            .filter((item) => item);
      }
      return [];
    },

    ...mapMutations({
      setShowDialog: "setShowDialog",
      setNewModel: "setNewModel",
      displaySuccess: "displaySuccess",
      displayError: "displayError",
      setCurrentModel: "setCurrentModel",
    }),

    _recompute() {
      if (!this.newModel || this.index !== 0 || !this.newModel.properties) {
        return;
      }

      console.log("getting statistics");
      var nxql = this._computeNXQL();
      const props = this.newModel.properties.map((v) => v.name);
      // TODO: create a ticket to make Core strip empty props
      const mid = Math.ceil(props.length / 2);
      const inputProps = props.slice(0, mid).join(",");
      const outputProps = props
          .slice(-mid)
          .join(",");

      this.$refs.aiStats.params = {
        query: nxql,
        inputs: inputProps,
        outputs: outputProps,
      };

      this.$refs.aiStats
          .execute()
          .then((response) => {
            if (!response || response.length === 0) {
              this.displaySuccess(this.$t("admin.ai.stats.none"));
            } else {
              response.forEach((item) => {
                item.severity = analyzer.severity(item);
              });
              this.statistics = response;
            }
          })
          .catch(() => {
            this.displayError(this.$t("admin.ai.stats.error"));
            console.log(this.$t("admin.ai.stats.error"));
          });
    },

    _computeNXQL() {
      var nxql = `SELECT * FROM Document WHERE ecm:primaryType = '${this.newModel.selectedDocType}'`;
      if (this.newModel.nxql) {
        nxql += ` AND ${this.newModel.nxql}`;
      }

      return nxql;
    },
  },
};
